import React, { useEffect, useState } from 'react'
import GetDiagnosisData from "../../services/general/getDiagnosisData.api";
import Select from 'react-select';
import {
    CButton,
    CFormLabel,
} from "@coreui/react";
import SaveExtra from "../../services/general/saveExtraData.api";
import SaveQuestionProvider from '../../services/general/saveQuestionsProvider.api'

const TitleCopy = ({ setParentAccordions, parentId = null, setModalVisible, LinkFor = 'assessment', type = 'AssesmentSuggestions', differentModuleCopyFunctionality = false }) => {

    const [suggestionData, setSuggestionData] = useState([])
    const [isPageLoading, setIsPageLoading] = useState(false)
    const [accordions, setAccordions] = useState(null)
    const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
    const [diagnosisOptions, setDiagnosisOptions] = useState([]);
    const [allSuggestions, setAllSuggestions] = useState([]);
    const [selectedTitles, setSelectedTitles] = useState([]);
    const [titleOptions, setTitleOptions] = useState([]);
    const [selectedModuleType, setSelectedModuleType] = useState({ value: 'AssesmentSuggestions', label: 'Assessment' })
    const [moduleType, setModuleType] = useState([
        { value: 'HPI', label: 'HPI' },
        { value: 'followup', label: 'Follow Up' },
        { value: 'Incident', label: 'Incident' },
        { value: 'AssesmentSuggestions', label: 'Assessment' },
        { value: 'differentialDiagnosis', label: 'Differential Diagnosis' },
        { value: 'generalPlanStatements', label: 'Template' }
    ])




    const extractLinkedAssessments = (data) => {

        const processOptions = (options) =>
            options?.reduce((acc, option) => {
                if (option.linkedAssessment) {
                    acc.push(...option.linkedAssessment);
                }

                if (option.linkedQuestion) {
                    if (Array.isArray(option.linkedQuestion)) {
                        option.linkedQuestion.forEach((nestedQuestion) => {
                            acc.push(...processOptions(nestedQuestion.options));
                        });
                    } else if (typeof option.linkedQuestion === "object") {
                        acc.push(...processOptions(option.linkedQuestion.options));
                    }
                }

                return acc;
            }, []) || [];

        return data?.questionData?.reduce((acc, question) => {
            acc.push(...processOptions(question.options));
            return acc;
        }, []) || [];
    };



    const getData = async (type = 'AssesmentSuggestions') => {
        setIsPageLoading(true)
        console.log("selectedDiagnosis======> template", type)
        try {
            if (type === 'AssesmentSuggestions' || type === 'differentialDiagnosis' || type === 'generalPlanStatements') {
                let data = await SaveExtra('Get_By_Type', type, '', '')
                data = JSON.parse(data.d)?.Data || [];
                if (data) {
                    data = data?.map((item) => {
                        return {
                            Id: item.Id,
                            Data: JSON.parse(item?.JsonData)
                        }
                    })
                }
                let result = data.filter((item) => item?.Data.diagnosis.value === selectedDiagnosis?.value)
                if (result.length > 0) {
                    handleAllTitles(result[0].Data.accordions)
                } else {
                    setTitleOptions([])

                }
                setSuggestionData(data);

            } else if (type === 'HPI' || type === 'Incident' || type === 'followup') {
                let formattedData;
                if (selectedDiagnosis) {
                    formattedData = await SaveQuestionProvider('GET', "", type, selectedDiagnosis?.value?.toString(), '')
                    if (formattedData) {
                        formattedData = JSON.parse(formattedData.d)?.Data || []
                        formattedData = formattedData[0] || []
                        if (formattedData.questionData) {
                            formattedData = {
                                ...formattedData,
                                questionData: JSON.parse(formattedData.questionData).filter(item => item !== null)
                            }
                        }
                        if (formattedData) {
                            const linkedAssessments = extractLinkedAssessments(formattedData);
                            if (linkedAssessments.length > 0) {
                                handleAllTitles(linkedAssessments)
                            } else {
                                setTitleOptions([])
                            }

                        }
                    }
                } else {
                    // window.alert("Please Select Diagnosis  ")
                }
            }
            // setSelectedDiagnosis(parentDiagnosis)

        } catch (error) {
            console.log(error)
        } finally {
            setIsPageLoading(false);
        }
    };


    const updateDiagnosisOptions = async () => {

        try {
            let response = await GetDiagnosisData("");
            let diagnosis = JSON.parse(response.d)?.Data;
            const options = diagnosis.map((item) => ({
                value: item.id,
                label: item.Name,
            }));
            setDiagnosisOptions(options);
        } catch (error) {
            console.error("Error updating diagnosis options:", error);
        }

    };


    const handleAllTitles = (allSuggestionsFromAccordions) => {


        const extractOptions = (items) => {
            return items.flatMap((item) => {
                const option = {
                    value: item.id,
                    label: item.title,
                    data: item,
                };

                const childOptions = item.children ? extractOptions(item.children) : [];

                return [option, ...childOptions];
            });
        };

        const title = extractOptions(allSuggestionsFromAccordions).filter(option => option.label);
        setTitleOptions(title)

    };


    const handleChangeDiagnosis = (type) => {
        console.log("selectedDiagnosis======>  type ", type)
        getData(type)
    }

    useEffect(() => {
        handleChangeDiagnosis(selectedModuleType.value)
    }, [selectedModuleType])

    useEffect(() => {
        if (selectedDiagnosis) {
            try {
                handleChangeDiagnosis(selectedModuleType.value)
            } catch (error) {
                console.error("Error updating diagnosis data:", error);
            }
        }
    }, [selectedDiagnosis])

    useEffect(() => {
        updateDiagnosisOptions()
        getData()
    }, [])

    // const handleSubmit = () => {
    //     console.log("selectedTitle ", selectedTitles)
    //     setParentAccordions((prev) => {

    //         const updatedAccordions = parentId
    //             ? updateNestedAccordions(prev.accordions, parentId, selectedTitles.map(t => t.data))
    //             : [...prev?.accordions, ...selectedTitles.map(t => t.data)];

    //         const updatedData = { ...prev, accordions: updatedAccordions };

    //         return updatedData;
    //     });
    // }
    const handleSubmit = () => {

        setParentAccordions((prev) => {
            const updatedAccordions = parentId
                ? updateNestedAccordions(
                    prev.accordions,
                    parentId,
                    selectedTitles.map(t => ({
                        ...t.data,
                        id: Date.now() + Math.random(),
                    }))
                )
                : [
                    ...prev?.accordions,
                    ...selectedTitles.map(t => ({
                        ...t.data,
                        id: Date.now() + Math.random(),
                    })),
                ];

            const updatedData = { ...prev, accordions: updatedAccordions };

            return updatedData;
        });
        setModalVisible(false)
    };



    const updateNestedAccordions = (list, parentId, newAccordion) =>
        list.map((item) =>
            item.id === parentId
                ? { ...item, children: [...item.children, ...newAccordion] }
                : { ...item, children: updateNestedAccordions(item.children, parentId, newAccordion) }
        );

    return (
        <div className='mx-2  '>
            <div
                className="pe-title-card p-4 rounded"
                style={{
                    marginBottom: '20px',
                    width: '100%',
                }}
            >
                <div className='d-flex flex-column justify-content-between align-item-center gap-2'>
                    {differentModuleCopyFunctionality && <div className="mb-3" style={{ width: '100%' }}>
                        <CFormLabel style={{ fontSize: '16px', fontWeight: 'bold' }}>
                            Select Module
                        </CFormLabel>
                        <Select
                            className="basic-single-select ui-react-select"
                            classNamePrefix="select"
                            value={selectedModuleType}
                            onChange={setSelectedModuleType}
                            options={moduleType}
                            isLoading={isPageLoading}
                        />
                    </div>}
                    <div className="mb-3" style={{ width: '100%' }}>
                        <CFormLabel style={{ fontSize: '16px', fontWeight: 'bold' }}>
                            Select Diagnosis
                        </CFormLabel>
                        <Select
                            className="basic-single-select ui-react-select"
                            classNamePrefix="select"
                            value={selectedDiagnosis}
                            onChange={setSelectedDiagnosis}
                            options={diagnosisOptions}
                            isPageLoading={isPageLoading}
                        />
                    </div>
                    <div className="mb-3" style={{ width: '100%' }}>
                        <CFormLabel style={{ fontSize: '16px', fontWeight: 'bold' }}>
                            Select Title
                        </CFormLabel>
                        <Select
                            className="basic-multi-select ui-react-select"
                            classNamePrefix="select"
                            value={selectedTitles}
                            onChange={setSelectedTitles}
                            options={titleOptions}
                            isPageLoading={isPageLoading}
                            isMulti
                        />
                    </div>
                </div>

            </div>
            <div className='text-end'>
                <CButton color="primary" onClick={handleSubmit} className='px-4 ui-action-btn ui-action-btn--primary'>Add</CButton>
            </div>
        </div>
    )
}

export default TitleCopy
